/* jshint esversion: 6 */

export function generaGtmEventId() {
	// i. e. 1637860718213.bx64i1n69gm
	const timestamp = Date.now();
	const caratteriPossibili = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let stringaCasuale = '';
	for (let i = 0; i < 11; i++) {
		stringaCasuale += caratteriPossibili.charAt(Math.floor(Math.random() * caratteriPossibili.length));
	}

	return timestamp + '.' + stringaCasuale;
}

function push_(event) {
	const dataLayer = window.dataLayer || [];
	event["ss_event_id"] = generaGtmEventId();
	dataLayer.push(event);
	console.log('GtmService.dataLayer', dataLayer);
}

export default class GtmService {

	static pageSetup(data) {
		return push_(data);
	}

	static pageView() {

		//	console.log("pageview1()");
		//const view = Array.prototype.slice.call(document.querySelectorAll('.view')).pop();
		

		return push_(
		//	JSON.parse(view.dataset.gtmPageview)

			{
				event: 'virtual_pageview',
				pageTitle: document.title,
				documentLocation: window.location.href,
				originalLocation: window.location.href,
				pagePath: window.location.pathname,
		//	hostname: window.location.hostname,
			}
		);
	}

	static pageView(pathname) {

		//console.log("pageviewpath()");
		//const view = Array.prototype.slice.call(document.querySelectorAll('.view')).pop();


		//return push_(
		//	JSON.parse(view.dataset.gtmPageview)
		//);

		const obj = {
			event: 'virtual_pageview',
			pageTitle: document.title,
			documentLocation: window.location.href,
			originalLocation: window.location.href,
			pagePath:/* pathname ||*/ (window.location.pathname + window.location.search),
		//	hostname: window.location.hostname,
		};
		Object.assign(obj, window.dataLayerData);
		return push_(obj);
	}

	static pageViewFilters(cat, filters) {
		const values = [];
		let any = false;
		var ss = "";
		for (let key in filters) {
			let textValue = '';
			const filterValue = filters[key].value;
			if (filterValue) {
				const selectedOption = filters[key].options.find(option => option.value === filterValue);
				if (selectedOption) {
					textValue = selectedOption.label;
				}
			}
			if (textValue) any = true;
			let name = filters[key].key /* se array di filtri */ || key /* se oggetto filtro */ ;
			if (name) name = encodeURIComponent(name) + '-';
			values.push(name + encodeURIComponent(textValue));
			ss += "-" + name + ":" + encodeURIComponent(textValue);
		}
		//const pathname = any ? `?cat=${cat}&s=${values.join('_')}` : '';
	//	console.log("..." + cat + "-" + ss);
	//	GtmService.pageView(window.location.pathname + pathname);
	}

	static push(event) {
		return push_(event);
	}

}
